<template>
  <div class="home-view">
    <section class="home-hero-shell">
      <HomeHeroSlider
        :slides="availableSlides"
        :labels="sliderLabels"
        @action="handleSlideAction"
      />
    </section>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import HomeHeroSlider from '@/components/home/HomeHeroSlider.vue';
import { homeSlideDefinitions } from '@/constants/homeSlides';
import { isAthlete, isJudge, isSupervisor } from '@/helpers/roleUtils';

export default {
  name: 'HomeLand',
  components: {
    HomeHeroSlider,
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['getUser']),
    userProfile() {
      return this.getUser;
    },
    canAccessTraining() {
      return isAthlete(this.userProfile) || isJudge(this.userProfile) || isSupervisor(this.userProfile);
    },
    availableSlides() {
      const context = {
        user: this.userProfile,
        canAccessTraining: this.canAccessTraining,
      };

      return homeSlideDefinitions
        .filter((slide) => (typeof slide.visibleWhen === 'function' ? slide.visibleWhen(context) : true))
        .map((slide) => this.resolveSlide(slide));
    },
    sliderLabels() {
      return {
        previous: this.translateText('home.slider.previous', 'Previous slide'),
        next: this.translateText('home.slider.next', 'Next slide'),
        pagination: this.translateText('home.slider.pagination', 'Home sections'),
        goTo: this.translateText('home.slider.go_to', 'Go to'),
      };
    },
  },
  methods: {
    translateText(key, fallback) {
      if (typeof this.$te === 'function' && this.$te(key)) {
        return this.$t(key);
      }

      return fallback;
    },
    resolveSlide(slide) {
      return {
        ...slide,
        eyebrow: this.translateText(slide.eyebrowKey, slide.eyebrowFallback),
        title: this.translateText(slide.titleKey, slide.titleFallback),
        description: this.translateText(slide.descriptionKey, slide.descriptionFallback),
        points: (slide.points || []).map((point) => this.translateText(point.key, point.fallback)),
        media: (slide.media || []).map((item) => ({
          ...item,
          alt: this.translateText(item.altKey, item.altFallback),
          caption: this.translateText(item.captionKey, item.captionFallback),
        })),
        actions: (slide.actions || []).map((action) => ({
          ...action,
          label: this.translateText(action.labelKey, action.labelFallback),
        })),
      };
    },
    handleSlideAction({ action }) {
      this.runAction(action);
    },
    openPrimarySlideAction(slide) {
      const primaryAction = slide.actions?.[0];
      if (!primaryAction) return;
      this.runAction(primaryAction);
    },
    runAction(action) {
      if (!action) return;

      if (action.kind === 'route' && action.to && this.$route.path !== action.to) {
        this.$router.push(action.to);
      }
    },
  },
};
</script>

<style scoped>
.home-view {
  display: flex;
  flex-direction: column;
}

.home-hero-shell {
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  padding: 0 24px 8px;
}

@media (max-width: 767.98px) {
  .home-hero-shell {
    padding: 0 12px 4px;
  }
}
</style>


